import { render, staticRenderFns } from "./operatemplateStyleWindow.vue?vue&type=template&id=c9836fe2"
import script from "./operatemplateStyleWindow.vue?vue&type=script&lang=js"
export * from "./operatemplateStyleWindow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports